const route = {
	path: '/registro',
	name: 'register',
	component: () => import('@/pages/page-register'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/register.js